import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../../../../../../_metronic/common/table/core/ListViewProvider'

export const StockCategoriesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <button type='button' className='btn btn-sm btn-primary' onClick={() => setItemIdForUpdate(null)}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add Stock Category
      </button>
    </div>
  )
}
